export default class UserItem {
    
    public constructor(id: string, fullName: string, isManager: boolean, selected: boolean = false){
        this.Id = id;
        this.FullName = fullName;
        this.IsManager = isManager;
        this.Selected = selected;
    }
    
    public Id : string;
    public FullName: string;
    public IsManager : boolean;
    public Selected: boolean;
}